// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.z4RXhiRqydilVMda0VsE {
  margin-top: 0px;
  margin-bottom: 0px;
  border-color: #bbb;
}
`, "",{"version":3,"sources":["webpack://./src/components/FlowSheetEditor/components/EditorActions/index.module.less"],"names":[],"mappings":"AAAA;EACE,eAAA;EACA,kBAAA;EACA,kBAAA;AACF","sourcesContent":[".divider {\n  margin-top: 0px;\n  margin-bottom: 0px;\n  border-color: #bbb;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"divider": `z4RXhiRqydilVMda0VsE`
};
export default ___CSS_LOADER_EXPORT___;
